// Global Types
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  CrewmemberAuthType,
  CrewmemberLanguage,
} from 'common.data';
import {
  AccessTokenKey,
} from 'common.types';

import * as authActionTypes from './types';

// Types
import type {
  $Services,
} from '../../../services';
import type {
  $Action,
  $ActionResult,
  $Dispatch,
  $State,
} from '../..';

// setupAuthentication action
type $SetupAuthenticationActionParams = void;
type $SetupAuthenticationActionResponse = $Model<'Crewmember'> | null;
export type $SetupAuthenticationAction = () => $ActionResult<$SetupAuthenticationActionResponse>;

export const setupAuthentication: $Action<
$SetupAuthenticationActionResponse,
$SetupAuthenticationActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: services.Api.getAuthUser(),
  type: authActionTypes.SETUP_AUTHENTICATION,
});

// authenticate action
type $AuthenticateActionParams = {
  language: CrewmemberLanguage;
  token: string;
  type: CrewmemberAuthType;
};
type $AuthenticateActionResponse = $Model<'Crewmember'>;
export type $AuthenticateAction = (
  arg0: $AuthenticateActionParams,
) => $ActionResult<$AuthenticateActionResponse>;

export const authenticate: $Action<
$AuthenticateActionResponse,
$AuthenticateActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.authenticate(params),
  type: authActionTypes.AUTHENTICATE,
});

// unauthenticate action
type $UnauthenticateActionParams = void;
type $UnauthenticateActionResponse = void;
export type $UnauthenticateAction = (
  arg0: $UnauthenticateActionParams,
) => $ActionResult<$UnauthenticateActionResponse>;

export const unauthenticate: $Action<
$UnauthenticateActionResponse,
$UnauthenticateActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.unauthenticate(),
  type: authActionTypes.UNAUTHENTICATE,
});

// setAuthUser action
type $SetAuthUserActionParams = $Model<'Crewmember'> | null;
type $SetAuthUserActionResponse = $Model<'Crewmember'> | null;
export type $SetAuthUserAction = (
  arg0: $SetAuthUserActionParams,
) => $ActionResult<$SetAuthUserActionResponse>;

export const setAuthUser: $Action<
$SetAuthUserActionResponse,
$SetAuthUserActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => {
    if (params === null) {
      services.Cookies.removeItem(AccessTokenKey.crewmember);
    }

    return params;
  },
  type: authActionTypes.SET_AUTH_USER,
});

// getAuthUser action
type $GetAuthUserActionParams = void;
type $GetAuthUserActionResponse = $Model<'Crewmember'> | null;
export type $GetAuthUserAction = (
  arg0: $GetAuthUserActionParams,
) => $ActionResult<$GetAuthUserActionResponse>;

export const getAuthUser: $Action<
$GetAuthUserActionResponse,
$GetAuthUserActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: services.Api.getAuthUser(),
  type: authActionTypes.GET_AUTH_USER,
});

// updateAuthUser action
type $UpdateAuthUserActionParams = $ModelUpsertParams<'Crewmember'>;
type $UpdateAuthUserActionResponse = $Model<'Crewmember'>;
export type $UpdateAuthUserAction = (
  arg0: $UpdateAuthUserActionParams,
) => $ActionResult<$UpdateAuthUserActionResponse>;

export const updateAuthUser: $Action<
$UpdateAuthUserActionResponse,
$UpdateAuthUserActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: services.Api.updateAuthUser(params),
  type: authActionTypes.UPDATE_AUTH_USER,
});

// deleteAuthUser action
type $DeleteAuthUserActionParams = void;
type $DeleteAuthUserActionResponse = $Model<'Crewmember'>;
export type $DeleteAuthUserAction = (
  arg0: $DeleteAuthUserActionParams,
) => $ActionResult<$DeleteAuthUserActionResponse>;

export const deleteAuthUser: $Action<
$DeleteAuthUserActionResponse,
$DeleteAuthUserActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: services.Api.deleteAuthUser(),
  type: authActionTypes.DELETE_AUTH_USER,
});
